import { render, staticRenderFns } from "./CidadeSelect.vue?vue&type=template&id=6823fd25&"
import script from "./CidadeSelect.vue?vue&type=script&lang=js&"
export * from "./CidadeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports